// NPM Imports
import React from "react";
import { connect } from "react-redux";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Tooltip } from "../../revvComponents";

// Internal Imports
import { GlobalUtils } from "../../utils";
import { FEATURES } from "../../constants";

// Destructuring
const { isFreeBillingPlan } = GlobalUtils;
const { LIMIT_EXHAUST_TEXT, LIMIT_USAGE_TEXT, PAID_USER_LIMIT_USAGE_TEXT } =
  FEATURES;

// Declarations

// ! TEMP LOGIC, REPLACE WHEN THE FLOW IS MOVED TO TOPBAR V3
const METERING_EVENT_NAME_MAP = {
  esignatures: "eSign",
  document_downloaded: "download",
  send_for_acceptance: "forAcceptance",
  send_to_someone: "forReviewer",
  digital_transactions: "digital_transactions",
};

class MeteredCounterV2 extends React.Component {
  state = {};

  render() {
    if (Object.keys(this.props.count).length > 0) {
      const { limit, usage } = this.props.count;
      const available = limit - usage;
      const percentage = (available / limit) * 100 || 0;
      const usageTxt = isFreeBillingPlan()
        ? LIMIT_USAGE_TEXT
        : PAID_USER_LIMIT_USAGE_TEXT;

      const _usageToolTipTxt = txt => {
        const a = txt.replace("[x]", available);
        const b = a.replace("[y]", limit);
        return b;
      };

      const _decideFontSize = () => {
        switch (`${available}`.length) {
          case 5:
            return "27px";
          case 4:
            return "28px";
          case 3:
            return "36px";
          default:
            return "40px";
        }
      };
      return (
        <div className="metered-counter-v2-wrapper">
          {available > 0 ? (
            <Tooltip
              placement="bottom"
              align={{
                offset: [0, 3],
              }}
              overlay={_usageToolTipTxt(usageTxt[this.props.name])}>
              <div
                data-test="metered-counter-btn"
                className="meter-counter-btn"
                onClick={e => {
                  e.stopPropagation();
                  if (isFreeBillingPlan()) {
                    this.props.togglePopUp(
                      true,
                      METERING_EVENT_NAME_MAP[this.props.name] ||
                        this.props.name,
                    );
                  }
                }}
                onKeyPress={() => {}}
                role="button"
                tabIndex="0">
                <span className="available-count">{available}</span>
                <CircularProgressbar
                  value={percentage}
                  // text={`${available}`}
                  strokeWidth={20}
                  styles={buildStyles({
                    strokeLinecap: "butt",
                    textSize: _decideFontSize(),
                    pathTransitionDuration: 0.5,
                    textColor: "#0b8c18",
                    pathColor: "#02ab31",
                    trailColor: "#ffadad",
                  })}
                />
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              placement="bottom"
              align={{
                offset: [0, 3],
              }}
              overlay={LIMIT_EXHAUST_TEXT[this.props.name]}>
              <div
                data-test="metered-counter-btn"
                onClick={e => {
                  e.stopPropagation();
                  if (isFreeBillingPlan()) {
                    this.props.togglePopUp(
                      true,
                      METERING_EVENT_NAME_MAP[this.props.name] ||
                        this.props.name,
                    );
                  }
                }}
                onKeyPress={() => {}}
                role="button"
                tabIndex="0">
                <span className="available-count">{available}</span>
                <CircularProgressbar
                  value={percentage}
                  // text="0"
                  strokeWidth={20}
                  styles={buildStyles({
                    strokeLinecap: "butt",
                    textSize: "40px",
                    pathTransitionDuration: 0.5,
                    textColor: "#0b8c18",
                    pathColor: "#02ab31",
                    trailColor: "#ffadad",
                  })}
                />
                {/* <img src={UPGRADE_STAR} alt="upgrade-start" /> */}
              </div>
            </Tooltip>
          )}
          {/* {available <= 0 && <img src={UPGRADE_STAR} alt="upgrade-start" />} */}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { metering: meteringUsage } = state.CommonStore;
  const count = meteringUsage[ownProps.name] || {};
  return {
    count,
  };
};

export default connect(mapStateToProps, null)(MeteredCounterV2);
